import { getActiveUser } from "services/apiMiddleware";
import { t } from "../../i18n";

const activeUser = {
  state: {
    isLoading: false,
    error: null,
    item: null,
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, user) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        item: user,
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async init() {
      try {
        dispatch.activeUser.loadStart();
        const { data } = await getActiveUser();
        dispatch.activeUser.loadSuccess(data);
      } catch (error) {
        console.error(error);
        dispatch.activeUser.failure(t("activeUser_load_error", { ns: "common" }));
      }
    },
  }),
};

export default activeUser;
